<div class="wrapper-modal">
	<ion-chip (click)="dismiss()" class="close-icon">
		<ion-icon src="../../../assets/topgolf/close_hover.svg"></ion-icon>
	</ion-chip>
	@if (!loading) {
		<div class="header-block">
			<ng-container>
				@if (doneOrders == null || doneOrders.length <= 0) {
					<ion-row class="ion-text-center ion-justify-content-center ion-margin">
						<span class="ion-text-center">{{ 'my_order.empty_finished_orders' | translate }}</span>
					</ion-row>
				}
				@for (order of orders; track order) {
					<div>
						<app-my-order [order]="order" class="ion-margin-horizontal"></app-my-order>
					</div>
				}
			</ng-container>
		</div>
	}
	@if (loading) {
		<div class="loading">
			<ion-spinner></ion-spinner>
		</div>
	}
</div>
